import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import {
  Field,
  FluentProvider,
  Radio,
  RadioGroup,
  webLightTheme,
} from '@fluentui/react-components';
import React from 'react';
import { Controller, FieldValues, UseFormMethods } from 'react-hook-form';
import { yesOption, noOption } from '../../../utils/types/CommonDropdownOptions';

export interface ITreasuryInformation {
  bankAccount?: boolean | null;
  ihcc?: boolean | null;
  uscc?: boolean | null;
  loan?: boolean | null;
}

interface IEntityTerminationTreasuryEditFormProps {
  form: UseFormMethods<FieldValues>;
  treasuryInfo?: ITreasuryInformation;
}

const EntityTerminationTreasuryEditForm = (
  props: IEntityTerminationTreasuryEditFormProps,
): JSX.Element => {
  const { form, treasuryInfo } = props;
  const { control } = form;

  const renderBooleanField = (
    name: string,
    label: string,
    defaultValue: boolean | null | undefined,
  ): JSX.Element => (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue ?? null}
      render={({ value, onChange }): React.ReactElement => (
        <Field label={label}>
          <RadioGroup
            id={name}
            name={name}
            value={value?.toString().toLowerCase()}
            onChange={(_e, radioData): void => {
              onChange(radioData.value === 'true');
            }}
          >
            <Radio value={yesOption.key} label={yesOption.text} />
            <Radio value={noOption.key} label={noOption.text} />
          </RadioGroup>
        </Field>
      )}
    />
  );

  return (
    <FluentProvider theme={webLightTheme}>
      <Stack tokens={{ childrenGap: 10 }}>
        {renderBooleanField('bankAccount', 'Bank Account', treasuryInfo?.bankAccount)}
        {renderBooleanField('ihcc', 'IHCC', treasuryInfo?.ihcc)}
        {renderBooleanField('uscc', 'USCC', treasuryInfo?.uscc)}
        {renderBooleanField('loan', 'Loan', treasuryInfo?.loan)}
      </Stack>
    </FluentProvider>
  );
};

export default EntityTerminationTreasuryEditForm;
